// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { filtersLayoutStyles } from "@steiner/App/Widgets/OrderHistory/OrderHistoryFiltersLayout";
import { DivWrapper } from "@steiner/XDL/constants";
import { css } from "styled-components";

filtersLayoutStyles.container = {
    css: css`
        padding: 12px;
        & > ${DivWrapper} {
            display: flex;
            gap: 12px;
            flex-wrap: wrap;
            align-items: flex-start;
            margin-left: auto;
            & > div:last-child {
                width: 100%;
                margin-left: auto;
                justify-content: flex-end;
                align-items: end;
                margin-top: auto;
            }
        }
    `,
};
